import React, {Component} from 'react';
import './index.scss';
import {fetchRss} from './fetcher'
import ChannelIntro from './components/ChannelIntro'
import ChannelEpisodes from './components/ChannelEpisodes'
import ChannelEpisode from './components/ChannelEpisode'
import PropTypes from 'prop-types'

class AkItunesFeed extends Component {

  constructor (props) {
    super(props)
    this.state = {
      rss: "",
      mode: "loading"
    }
  }

  componentDidMount() {
    fetchRss(this.props.rssUrl).then((rss) => {
      if (this.props.episodeId) {
      this.setState({
        rss: rss,
        mode: "single"
      })
      } else {
        this.setState({
        rss: rss,
        mode: "list"
      })
      }
    })
  }

  render () {

    const loadingRender = (
      <div className="d-flex justify-content-center">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    )

    var renderable



    switch(this.state.mode) {
      case 'loading':
        renderable = loadingRender
        break
      case 'single':
        const episode = this.state.rss.items.find((episode) => episode.guid === this.props.episodeId)
        renderable = (
          <ChannelEpisode episode={episode}/>
        )
        break
      case 'list':
        var channelIntro
        if (this.props.showIntro) {
            channelIntro = (
              <ChannelIntro
                title={this.state.rss.title}
                subtitle={this.state.rss.itunes.subtitle}
                summary={this.state.rss.itunes.summary}
                imageUrl={this.state.rss.itunes.image}
              />
            )
          }
          renderable = (
            <div className="container">
              {channelIntro}
              <ChannelEpisodes episodes={this.state.rss.items}/>
            </div>
          )
        break
      default:
        renderable = loadingRender
        break
    }
    return  renderable
  }

}

AkItunesFeed.propTypes = {
  showIntro: PropTypes.bool.isRequired,
  rssUrl: PropTypes.string.isRequired,
  episodeId: PropTypes.string
}
export default AkItunesFeed
